import {useState} from "react";
import {DatePicker} from "antd";
import {InputField, SelectField, SelectUserAll} from "~/components/Forms";

const STATUS_OPTIONS = [
	{value: 'upcoming',     label: 'Chờ / Đang diễn ra'},
	{value: 'trained',      label: 'Đã đào tạo'},
	{value: 'not_trained',  label: 'Chưa đào tạo'},
	{value: 'postponed',    label: 'Đời lịch'},
	{value: 'cancelled',    label: 'Đã hủy'},
];

function TrainingScheduleSearchBar({filter, onSearchChange, onChange}) {

	const [trainerOptions, setTrainerOptions] = useState([]);

	const handleKeywordChange = (e) => {
		onSearchChange({...filter, keyword: e.target.value, page: 1});
	};

	const handleTrainerChange = (val) => {
		onChange({...filter, trainerId: val || undefined, page: 1});
	};

	const handleStatusChange = (val) => {
		onChange({...filter, status: val || undefined, page: 1});
	};

	const handleDateChange = (dates) => {
		onChange({
			...filter,
			startFrom: dates ? dates[0].startOf('day').unix() : undefined,
			startTo:   dates ? dates[1].endOf('day').unix()   : undefined,
			page:      1,
		});
	};

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField
						name="keyword"
						placeholder="Tìm chủ đề đào tạo..."
						defaultValue={filter?.keyword || ''}
						onChange={handleKeywordChange}
					/>
					<SelectUserAll
						name="trainerId"
						placeholder="Người đào tạo"
						options={trainerOptions}
						setOptions={setTrainerOptions}
						onlyActive={1}
						value={filter?.trainerId || undefined}
						onChange={handleTrainerChange}
						label=""
						errors={{}}
						allowClear
					/>
					<DatePicker.RangePicker
						format="DD/MM/YYYY"
						placeholder={['Từ ngày', 'Đến ngày']}
						onChange={handleDateChange}
						style={{height: 38}}
					/>
					<SelectField
						name="status"
						placeholder="Trạng thái"
						options={STATUS_OPTIONS}
						value={filter?.status || undefined}
						onChange={handleStatusChange}
						allowClear
					/>
				</form>
			</div>
		</div>
	);
}

export default TrainingScheduleSearchBar;
